import type {
  AnswerSnapshot,
  OutcomeKey,
  OutcomeWeights,
  ReadinessQuestion
} from './types';

export function computeOutcomeKey(
  questions: readonly ReadinessQuestion[],
  answers: Record<string, string>
): OutcomeKey {
  const totals: OutcomeWeights = { soon: 0, foster: 0, ready: 0 };

  for (const question of questions) {
    const value = answers[question.id];
    if (!value) continue;
    const option = question.options.find((o) => o.value === value);
    if (!option) continue;
    totals.soon += option.soon;
    totals.foster += option.foster;
    totals.ready += option.ready;
  }

  if (totals.ready > totals.soon && totals.ready >= totals.foster) {
    return 'ready';
  }
  if (totals.foster >= totals.soon && totals.foster >= totals.ready) {
    return 'foster';
  }
  return 'soon';
}

export function isEveryQuestionAnswered(
  questions: readonly ReadinessQuestion[],
  answers: Record<string, string>
): boolean {
  return questions.every((question) =>
    question.options.some((option) => option.value === answers[question.id])
  );
}

export function buildAnswerSnapshot(
  questions: readonly ReadinessQuestion[],
  answers: Record<string, string>
): AnswerSnapshot[] | null {
  const snapshot: AnswerSnapshot[] = [];
  for (const question of questions) {
    const option = question.options.find(
      (candidate) => candidate.value === answers[question.id]
    );
    if (!option) return null;
    snapshot.push({
      questionId: question.id,
      prompt: question.prompt,
      optionValue: option.value,
      optionLabel: option.label
    });
  }
  return snapshot;
}
